import { HTTP } from "@/http-common.js";
import recognizedRoles from "@/roles.js";

export default {
  methods: {
    sortByName(arrayToSort, nameField) {
      if (arrayToSort.length <= 1) return arrayToSort;

      return arrayToSort.sort((a, b) => {
        let nameArrayA = [];
        let nameArrayB = [];

        let lastA;
        let lastB;

        if (a[nameField].indexOf("Home Office") < 0) {
          nameArrayA = a[nameField].split(",");
          lastA = nameArrayA[0];
        } else {
          lastA = a[nameField];
        }

        if (b[nameField].indexOf("Home Office") < 0) {
          nameArrayB = b[nameField].split(",");
          lastB = nameArrayB[0];
        } else {
          lastB = b[nameField];
        }

        if (lastA > lastB) return 1;
        if (lastB > lastA) return -1;

        if (lastA == lastB) {
          if (lastA == "Home Office") {
            if (a["ao"] && b["ao"]) {
              let idA = a["ao"].split(" ")[0];
              let idB = b["ao"].split(" ")[0];

              if (idA > idB) return 1;
              if (idB > idA) return -1;

              return 0;
            } else return 0;
          }

          let firstA = nameArrayA[1].trim();
          let firstB = nameArrayB[1].trim();

          if (firstA > firstB) return 1;
          if (firstB > firstA) return -1;
        }

        return 0;
      });
    },
    buildRef(member) {
      if (!member) return null;
      return member.name.replace(" ", "") + "_" + member.id;
    },
    addToAuditLog(section, action) {
      try {
        const user = this.$store.state.currentUser;
        const username = user ? (user.username ?  user.username : this.$store.state.tmkClientId) : "unknown";
        const name = user ? user.name : "unknown";
        const log = `[AMT AUDIT] [${section}] User: ${username} (${name}) | Action: ${action}`;
        HTTP.post("log", { log: log }).catch(() => {});
      } catch (e) {
        this.addToErrorLogs("addToAuditLog", e);
      }
    },
    addToErrorLogs(process, e) {
      try {
        let log = process + ": " + (e.message ? e.message : JSON.stringify(e));
        
        HTTP.post("log", { log: log })
          .then(response => {
            if (response.status != 200) {
              console.log(log);
            }
          })
          .catch(() => {
            console.log(log);
          });
      } catch (e) {
        console.log(e);
      }
    },
    fC() {
      try {
        return (((1 + Math.random()) * 0x10000) | 0)
          .toString(16)
          .substring(1)
          .toUpperCase();
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell fc", e);
        return "";
      }
    },
    PseudoGuid() {
      return (
        this.fC() +
        this.fC() +
        "-" +
        this.fC() +
        "-" +
        this.fC() +
        "-" +
        this.fC() +
        "-" +
        this.fC() +
        this.fC() +
        this.fC()
      );
    },
    isMobileCheck() {
      var hasTouchScreen = false;
      if ("maxTouchPoints" in navigator) {
        hasTouchScreen = navigator.maxTouchPoints > 0;
      } else if ("msMaxTouchPoints" in navigator) {
        hasTouchScreen = navigator.msMaxTouchPoints > 0;
      } else {
        var mQ = window.matchMedia && matchMedia("(pointer:coarse)");
        if (mQ && mQ.media === "(pointer:coarse)") {
          hasTouchScreen = !!mQ.matches;
        } else if ("orientation" in window) {
          hasTouchScreen = true; // deprecated, but good fallback
        } else {
          // Only as a last resort, fall back to user agent sniffing
          var UA = navigator.userAgent;
          hasTouchScreen =
            /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
            /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
        }
      }

      this.isMobileVar = hasTouchScreen;
    }
  },
  computed: {
    isMobile() {
      return this.isMobileVar;
    },
    isEditUser() {
      if (
        this.$store.state.userRoles.indexOf(
          recognizedRoles.roles.HomeOfficeReadWrite
        ) >= 0 ||
        this.$store.state.userRoles.indexOf(recognizedRoles.roles.Agency) >= 0 ||
        this.$store.state.userRoles.indexOf(
          recognizedRoles.roles.IAMAdmin
        ) >= 0
      )
        return true;

      return false;
    },

    isHomeOfficeUser() {
      return (
        this.$store.state.userRoles.indexOf(
          recognizedRoles.roles.HomeOfficeReadWrite
        ) >= 0 ||
        this.$store.state.userRoles.indexOf(
          recognizedRoles.roles.HomeOfficeReadOnly
        ) >= 0 ||
        this.$store.state.userRoles.indexOf(
          recognizedRoles.roles.IAMAdmin
        ) >= 0
        
      );
    },
    isAgencyUser() {
      return (
        this.$store.state.userRoles.indexOf(recognizedRoles.roles.Agency) >= 0
      );
    }
  },
  data() {
    return {
      errorLogs: [],
      isMobileVar: false
    };
  }
};
